import { isString } from '@sa/utils';
import { useState } from 'react';

export default function useModal<T extends Record<string, boolean>, R = (keyof T)[]>(data: T) {
  const [modal, setModal] = useState(data);
  return {
    closeModal: (keys: keyof T | R) => {
      const _modal: Record<string, false> = {};
      let _keys: any[] = [];
      if (isString(keys)) {
        _keys = [keys];
      }
      for (const key of _keys) {
        _modal[key] = false;
      }
      setModal({
        ...modal,
        ..._modal
      });
    },
    modal,
    openModal: (keys: keyof T | R) => {
      const _modal: Record<string, true> = {};
      let _keys: any[] = [];
      if (isString(keys)) {
        _keys = [keys];
      }
      for (const key of _keys) {
        _modal[key] = true;
      }
      setModal({
        ...modal,
        ..._modal
      });
    }
  };
}
